var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 625,
    viewBox: "0 0 664 625",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M433.247 76.3301L331.849 177.184L230.759 76.3301V0H147.49V110.663L331.849 294.591L516.515 110.663V0H433.247V76.3301Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.759 548.091L332.156 447.237L433.247 548.091V624.421H516.515V513.758L332.156 330.137L147.49 513.758V624.421H230.759V548.091Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M587.491 414.461L486.401 313.301L587.491 212.141H664V129.373H553.078L368.719 313.301L553.078 497.229H664V414.461H587.491Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5089 212.141L177.599 313.607L76.5089 414.461H0V497.229H110.923L295.281 313.607L110.923 129.373H0V212.141H76.5089Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparent);
export default __webpack_public_path__ + "static/media/transparent.2b87ce9bd36afed47991fc3fdc682433.svg";
export { ForwardRef as ReactComponent };